import { render, staticRenderFns } from "./loading-icon.vue?vue&type=template&id=ae263590&scoped=true"
import script from "./loading-icon.vue?vue&type=script&lang=js"
export * from "./loading-icon.vue?vue&type=script&lang=js"
import style0 from "./loading-icon.vue?vue&type=style&index=0&id=ae263590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae263590",
  null
  
)

export default component.exports